/* eslint-disable react/prop-types */
import React from 'react';

import { createStyles, TableCell, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const styles = (_theme: Theme) =>
  createStyles({
    tableCellBorder: {
      borderColor: 'rgba(0,0,0,.12)',
      borderWidth: '0 0 1px 1px',
      borderCollapse: 'separate',
      borderLeftStyle: 'solid',
      borderBottomStyle: 'solid',
    },
  });

const useStyles = makeStyles(styles);

interface NkTableCellProps {
  children?: React.ReactNodeArray | React.ReactNode;
}

export const NkTableCell = ({ children }: NkTableCellProps) => {
  const classes = useStyles();

  return <TableCell className={classes.tableCellBorder}>{children}</TableCell>;
};

export default NkTableCell;
